<template>
  <FullScreenPopup
    ref="popup"
    :closeable="true"
    :lock-scroll="true"
    title="Оберіть варіант відправки коду"
  >
    <div class="otp-direction__content">
      <div class="otp-direction__options">
        <RadioButton
          v-model="otpType"
          name="otp-type"
          :value="1"
        >
          Email
        </RadioButton>
        <RadioButton
          v-model="otpType"
          name="otp-type"
          :value="2"
        >
          Viber/SMS
        </RadioButton>
      </div>
      <div class="otp-direction__switch">
        <Checkbox
          v-model="commissionPaidByClient"
          label="Комісію сплачує клієнт"
        />
      </div>

      <div class="otp-direction__actions">
        <BlueButton
          class="otp-direction__actions-btn"
          @click="onSend"
        >
          Відправити
        </BlueButton>
        <BlueOutlineButton
          class="otp-direction__actions-btn"
          @click="onClose"
        >
          Скасувати
        </BlueOutlineButton>
      </div>
    </div>
  </FullScreenPopup>
</template>

<script>
import { BlueButton, BlueOutlineButton, Checkbox, RadioButton } from '@/shared/ui/form';
import { FullScreenPopup } from '@/shared/ui/popup';

export default {
  components: { FullScreenPopup, RadioButton, Checkbox, BlueOutlineButton, BlueButton },
  data() {
    return {
      otpType: 1,
      commissionPaidByClient: true,
    };
  },
  computed: {
    commissionPaidBy() {
      return this.commissionPaidByClient ? 'client' : 'agent';
    },
  },
  methods: {
    open() {
      this.otpType = 1;
      this.commissionPaidByClient = true;
      this.$refs.popup.open();
    },
    onClose() {
      this.$refs.popup.close();
    },
    onSend() {
      this.$emit('send', { type: this.otpType, commissionPaidBy: this.commissionPaidBy });
      this.$refs.popup.close();
    },
  },
};
</script>

<style scoped lang="scss">
.otp-direction {
  &__content {
    display: flex;
    flex-direction: column;
  }

  &__options {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-bottom: 24px;
  }

  &__switch {
    margin-bottom: 8px;
  }

  &__actions {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 16px;

    &-btn {
      padding: 16px 24px;
    }
  }
}

::v-deep .fullscreen-popup__content-wrapper {
  max-width: 500px;
}
</style>